import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import ticketImage from '../../../../images/sales-stream/sales-stream-ticket.svg';

const TargetLabel = props => {
  const { target } = props;
  return (
    <div style={{ marginTop: '5px' }}>
      <Typography style={{ fontSize: '10px', fontWeight: 400, lineHeight: '12.1px' }}>Target</Typography>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img alt="tickets" src={ticketImage} style={{ width: '11px', height: '7px', marginRight: '4px' }} />
        <Typography style={{ fontSize: '10px', fontWeight: 400, lineHeight: '12.1px' }}>{target}</Typography>
      </div>
    </div>
  );
};

TargetLabel.propTypes = {
  target: PropTypes.number.isRequired,
};

export default TargetLabel;
